__turbopack_context__.v({
  "root": "ComponentDetail-Team-module-scss-module__bmcpJW__root",
});
